<template>
    <div class="container">
        <card>
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="itemList.length > 5? '没有更多了' : ''"
                @load="loadMoreList"
                v-if="itemList.length > 0"
            >
                <div
                    @click="item.type==1?$router.push({path:'/guide/awardDetail', query:{info: JSON.stringify(item)}}):$router.push({path:'/guide/penaltyDetail', query:{info: JSON.stringify(item)}})"
                    v-for="(item,index) in itemList"
                    :key="index"
                >
                    <div class="line-item">
                        <div
                            class="l-txt"
                            :class="item.type==1?'award':'penalty'"
                        >{{item.type==1?'奖':'惩'}}</div>
                        <div class="r-txt">
                            <div class="tit">{{item.name}}</div>
                            <div class="time-warp">
                                <div class="tit">{{item.time.substring(0,10)}}</div>
                                <img class="img" src="@/assets/travelAgency/right.png" />
                            </div>
                        </div>
                    </div>
                    <rline></rline>
                </div>
            </van-list>
        </card>
        <empty :type="3" v-if="itemList.length === 0  && !loading"></empty>
    </div>
</template>
<script>
    import api from '../../service/modules/guide';
    import rline from '../travelAgency/components/line';
    import card from '../travelAgency/components/card';
    import empty from 'comps/empty';
    export default {
        components: {
            rline,
            card,
            empty
        },

        data () {
            return {
                itemList: [],
                guideId: 0,
                loading: false,
                finished: false,
                punishPagination: { total: 3, current_page: 1, page_size: 10 },
                awardPagination: { total: 3, current_page: 1, page_size: 10 }
            };
        },

        computed: {},

        watch: {},

        methods: {
            loadMoreList () {
                this.getAwards()
            },
            // 导游奖惩信息拉取
            getAwards () {
                this.loading = true;
                // this.finished = true
                api.guideAwardList({
                    guideId: this.guideId,
                    pageSize: this.awardPagination.page_size,
                    pageNo: this.awardPagination.current_page
                }).then(res => {
                    if (res.ret === 0) {
                        let finished = true
                        let awardsList = [];
                        res.data.list.forEach(element => {
                            element.type = 1;
                            element.time = this.formatDate(element.awardTime);
                            element.name =
                                element.awardDetail === null
                                    ? element.awardLevel + element.awardType
                                    : element.awardDetail;
                            awardsList.push(element);
                        });
                        if (res.data.pagination.total > (res.data.pagination.current_page * res.data.pagination.page_size)) {
                            res.data.pagination.current_page = res.data.pagination.current_page + 1
                            finished = false
                        }
                        this.awardPagination = res.data.pagination
                        api.guidePunish({
                            guideId: this.guideId,
                            pageSize: this.punishPagination.page_size,
                            pageNo: this.punishPagination.current_page
                        }).then(res => {
                            if (res.ret === 0) {
                                if (res.data.pagination.total > (res.data.pagination.current_page * res.data.pagination.page_size)) {
                                    res.data.pagination.current_page = res.data.pagination.current_page + 1
                                    finished = false
                                }
                                res.data.list.forEach(element => {
                                    element.type = 2;
                                    element.time = this.formatDate(
                                        element.decideDate
                                    );
                                    element.name =
                                        element.punishMethod === null
                                            ? element.punishType
                                            : element.punishMethod;
                                    awardsList.push(element);
                                });
                                awardsList.sort((a, b) => {
                                    return b.time > a.time ? 1 : -1;
                                });
                                this.punishPagination = res.data.pagination
                                this.awardTotal = awardsList.length;
                                // awardsList = awardsList.splice(0, 3);
                                this.itemList = this.itemList.concat(awardsList);
                                this.finished = finished
                                this.loading = false
                            }
                        });
                    }
                });
            // api.rewardsAndPunishment({
            //     type: 'l2PractisingStandard',
            //     guideId: this.guideId
            // })
            //     .then(res => {
            //         this.loading = false
            //         if (res.ret === 0) {
            //             let awardsList = []
            //             this.itemList = []
            //             res.data.award.forEach(element => {
            //                 element.type = 1
            //                 element.time = this.formatDate(element.awardTime)
            //                 element.name = !element.awardDesc ? element.awardLevel + element.awardType : element.awardDesc
            //                 awardsList.push(element)
            //             });
            //             res.data.punish.forEach(element => {
            //                 element.type = 2
            //                 element.time = this.formatDate(element.punishTime)
            //                 element.name = !element.punishDesc ? element.punishDetailType : element.punishDesc
            //                 awardsList.push(element)
            //             });
            //             awardsList.sort((a, b) => {
            //                 return b.time < a.time ? 1 : -1
            //             })
            //             this.itemList = awardsList
            //             // console.log(this.itemList)
            //         }
            //     });
            },
            // 时间戳转日期
            formatDate (timestamp) {
                var time = new Date(timestamp);
                var y = time.getFullYear();
                var m =
                    time.getMonth() + 1 < 10
                        ? '0' + (time.getMonth() + 1)
                        : time.getMonth() + 1;
                var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                var h =
                    time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
                var mm =
                    time.getMinutes() < 10
                        ? '0' + time.getMinutes()
                        : time.getMinutes();
                let date = y + '-' + m + '-' + d + ' ' + h + ':' + mm;
                return date;
            }
        },

        mounted () {},
        created () {
            this.punishPagination = { total: 3, current_page: 1, page_size: 10 }
            this.awardPagination = { total: 3, current_page: 1, page_size: 10 }
            this.itemList = []
            this.guideId = this.$route.query.guideId;
            this.getAwards();
        }
    };
</script>
<style scoped lang="less">
.container {
    height: 100vh;
    background-color: @base-bgcolor;
    padding: 16px 12px;

    .line-item {
        padding: 16px;
        display: flex;

        .l-txt {
            width: 18px;
            height: 16px;

            border-radius: 1px;
            margin-right: 8px;
            text-align: center;
            line-height: 16px;
            color: #fff;
        }

        .award {
            background: rgba(54, 179, 116, 1);
        }

        .penalty {
            background: #ff4d4d;
        }

        .r-txt {
            flex: 1;

            .tit {
                font-size: 14px;

                font-weight: 400;
                color: rgba(51, 51, 51, 1);
            }

            .time-warp {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 12px;

                .tit {
                    font-size: 12px;

                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                }

                .img {
                    width: 12px;
                    height: 12px;
                }
            }
        }
    }
}
</style>
